/* ---------------------------------------------------------------------
Global Js
Target Browsers: All
------------------------------------------------------------------------ */

var FX = (function(FX, $) {

    /**
     * Doc Ready
     */
    $(function() {
        FX.Products.init();
        FX.ReadMore.init();
        FX.ExternalLinks.init();
        FX.Social.init();
        FX.ImAHuman.init();
        FX.Slideshows.init();
        FX.SearchTrigger.init();
		FX.Galleries.init();
        FX.Coupons.init();

		if ( $('.selectric-select').length ) {
            $('.selectric-select').selectric();
        }
        if ( $('input').length ) {
            $('input').iCheck();
			$('input').on('ifChecked', function(e){
			  $(this).trigger("change", e);
			});
			$('input').on('ifUnchecked', function(e){
			  $(this).trigger("change", e);
			});
        }
    });

    FX.Products = {
        init: function() {
            this.bind();
        },
        bind: function() {
            $( '.read-more' ).click( this.toggleReadMore );
        },
        toggleReadMore: function() {
            $readmore = $( this );
            $table = $readmore.parents( '.product-table' );
            $table.toggleClass( 'js-active' );
            if ( $table.hasClass( 'js-active' ) ) {
                $readmore.find( 'span' ).text( 'View Less' );
            } else {
                $readmore.find( 'span' ).text( 'View More' );
            }
        }
    };

    FX.ReadMore = {
        init: function() {
            $('.extra-text').hide();
            $('.button-wrapper').show();

            $('.read--more').click(function(){
                $(this).fadeOut('fast');
                $(this).next('.hide--this').fadeIn('slow');
                $(this).parent().prev('.extra-text').slideDown('fast');
            });

            $('.hide--this').click(function(){
                $(this).fadeOut('fast');
                $(this).prev('.read--more').fadeIn('slow');
                $(this).parent().prev('.extra-text').slideUp('fast');
            });
        }
    };

    FX.Coupons = {
        init: function() {
            this.bind();
        },
        setFloodLight: function(id, type, cat) {

            var axel = Math.random() + "";
            var a = axel * 10000000000000;
            var flDiv=document.body.appendChild(document.createElement("div"));
            flDiv.setAttribute("id","DCLK_FLDiv"+id);
            flDiv.style.position="absolute";
            flDiv.style.top="0";
            flDiv.style.left="0";
            flDiv.style.width="1px";
            flDiv.style.height="1px";
            flDiv.style.display="none";
            flDiv.innerHTML='<iframe id="DCLK_FLIframe"'+id+' src="https://8586716.fls.doubleclick.net/activityi;src=8586716;type=' + type + ';cat=' + cat + ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"><\/iframe>';

        },
        bind: function() {
            $('#couponLoginForm').find('form').first().on('submit', this.loginSubmitHandler);
            $('#couponRegistrationForm').find('form').first().on('submit', this.registerSubmitHandler);
            //$('.footerStoreLocatorBtn').click(this.storeLocatorClickHandler);
        },
        loginSubmitHandler: function(e) {
            FX.Coupons.setFloodLight('Login', 'ip1810', 'coupo00');
        },
        registerSubmitHandler: function(e) {
            FX.Coupons.setFloodLight('Registration', 'ip1810', 'coupo000');
        },
        storeLocatorClickHandler: function(e) {
            FX.Coupons.setFloodLight('StoreLocator', 'ip1810', 'landi002');
        }
    };

    /**
     * Mobile menu script for opening/closing menu and sub menus
     * @type {Object}
     */
    FX.MobileMenu = {
        init: function() {
            $('.nav-primary li.menu-item-has-children > a').after('<span class="sub-menu-toggle icon-arrow-down hidden-md-up"></span>');

			$('.sub-menu-toggle').click( function() {
				var $this = $(this),
				$parent = $this.closest("li"),
				$wrap = $parent.find("> .sub-menu");
				$wrap.toggleClass("js-toggled");
				$this.toggleClass("js-toggled");
			});
        }
    };

    /**
     * Force External Links to open in new window.
     * @type {Object}
     */
    FX.ExternalLinks = {
        init: function() {
            var siteUrlBase = FX.siteurl.replace(/^https?:\/\/((w){3})?/,'')

            $('a[href*="//"]:not([href*="'+siteUrlBase+'"])')
                .not('.ignore-external') // ignore class for excluding
                .addClass('external')
                .attr('target', '_blank')
                .attr('rel', 'noopener');
        }
    };

    /**
     * Custom Social Share icons open windows
     * @type {Object}
     */
    FX.Social = {
        init: function() {
            $(".js-social-share").on("click", this.open);
        },

        open: function(event) {
          event.preventDefault();
          FX.Social.windowPopup($(this).attr("href"), 500, 300);
        },

        windowPopup: function (url, width, height) {
            var left = (screen.width / 2) - (width / 2),
                top = (screen.height / 2) - (height / 2);

            window.open(
                url,
                "",
                "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
            );
        }
    };

    /**
     * ImAHuman
     * Hidden Captchas for forms
     * @type {Object}
     */
    FX.ImAHuman = {
        num: "0xFF9481",
        forms: void 0,

        init: function() {
            this.setup()
        },

        setup: function() {
            this.forms = document.getElementsByTagName("form");
            this.bind();
        },

        bind: function() {
            for (var i = 0; this.forms.length > i; i++) {
                $(this.forms[i]).on("focus click", this.markAsHuman);
            }
        },

        markAsHuman: function() {
            $(this).find('.imahuman, [name="imahuman"]').attr("value", parseInt(FX.ImAHuman.num, 16))
        }
    };

    /**
     * Affix
     * Fixes sticky items on scroll
     * @type {Object}
     */

    FX.Affix = {
        windowHeight: 0,

        init: function() {
            this.windowHeight = $(window).height();
            this.bind();
        },

        bind: function(e) {
            $(window).on('scroll', this.scroll);
            $(window).on('resize', this.updateWindowHeight);
        },

        scroll: function(e) {
            var scrolltop = $(this).scrollTop(),
                fixPoint  = FX.Affix.windowHeight - $('#masthead').height();

            if(scrolltop >= fixPoint) {
                $('body').addClass('affix-head');
            } else {
                $('body').removeClass('affix-head');
            }
        },

        updateWindowHeight: function(e) {
            FX.Affix.windowHeight = $(window).height();
        }
    };

    /**
     * FX.Parallax
     * Parallax effect for images
     * @type {Object}
     */
    FX.Parallax = {
        init: function() {
            this.bind();
        },

        bind: function() {
            $(window).scroll(this.scroll);
        },

        scroll: function(e) {
            $('.js-parallax').each(function(){

                var $this   = $(this),
                    $speed  = $this.data('speed') || 6,
                    $window = $(window),
                    yPos    = -($window.scrollTop() / $speed),
                    coords  = 'center '+ yPos + 'px';

                $this.css({ backgroundPosition: coords });
            });
        }
    };

    /**
     * FX.SmoothAnchors
     * Smoothly Scroll to Anchor ID
     * @type {Object}
     */
    FX.SmoothAnchors = {
        init: function() {
            this.hash = window.location.hash;

            if ( this.hash != '' ) {
                this.scrollToSmooth(this.hash);
            }

            this.bind();
        },

        bind: function() {
            $('a[href^="#"]').on('click', $.proxy(this.onClick, this));
        },

        onClick: function(event) {
            event.preventDefault;
            var target = $(event.currentTarget).attr('href');
            this.scrollToSmooth(target);
        },

        scrollToSmooth: function(target) {
            var $target = $( $target );
            $target = ($target.length) ? $target : $( this.hash );

            var headerHeight = 0; // TODO: if using sticky header change 0 to
			// $('#page-header').outerHeight(true)

            if ($target.length) {
                var targetOffset = $target.offset().top - headerHeight;
                $('html,body').animate({scrollTop: targetOffset}, 600);
                return false;
            }
        }
    };

    /**
     * Tab Content
     * @type {Object}
     */
    FX.Tabs = {
        init: function() {
            $('.js-tabs').on('click touchstart', 'a', this.switchTab)
        },

        switchTab: function(event) {
            event.preventDefault();

            var $this = $(this),
                $tab  = $($this.attr('href'));

            $this.parent()
				.addClass('active')
				.siblings()
				.removeClass('active');

            $tab.addClass('active')
                .siblings()
                .removeClass('active');
        }
    };

    /**
     * Various slideshows
     */
    FX.Slideshows = {

        init: function() {
            this.bind();
        },

        bind: function() {
            // Homepage slideshow
            $('.js-slideshow').slick({
                slidesToShow: 1,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 6000,
                dots: true,
                dotsClass: "slick-dots dots-container"
            });

            // Homepage testimonial slideshow
            $('.testimonial-slider').slick({
                slidesToShow: 1,
                adaptiveHeight: true,
                autoplay: false,
                arrows: true,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
            });

            $('.product-reviews__slider').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: false,
                arrows: true,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
                responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        arrows: true
                      }
                    }
                ]
            });

            $('.recipe-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.recipe-slider-nav'
            });

            $('.recipe-slider-nav').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.recipe-slider',
                focusOnSelect: true,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
            });
        }
    };

	/**
     * Search Trigger
     */
    FX.SearchTrigger = {
        init: function() {
            this.bind();
        },

        bind: function() {
            $('.js-search-trigger').on('click', this.toggleVisibility);
        },

        toggleVisibility: function(event) {
            event.preventDefault();
            $('#site-search-popup, .page-body').toggleClass('visible');
            $('.icon-search').toggleClass('active');
        }
    };

    /**
     * Galleries Display
     */
    FX.Galleries = {

        init: function() {
			var self = FX.Galleries,
				$galleries = $('.gallery');

			$galleries.each(self.initGallery);
		},

       initGallery: function() {
			var self = FX.Galleries,
				$gallery = $(this);
			gallery_id = $gallery.attr('id'),
			$items = $gallery.find('div.gallery-item'),
			$all_items = $items.clone();

			self.fancybox($items, gallery_id);

			if ($gallery.hasClass('video-gallery'))
			{
				var $dropdown = $gallery.find('select.videofx_video_category');
				$dropdown.change(function() {
					var val = $dropdown.val();

					$items.remove();
					$items = $all_items.clone();

					if (val) {
						$items = $items.filter('[data-categories~='+val+']');
					}

					$gallery.append($items);
					self.fancybox($items, gallery_id);

				});
			}
		},

		fancybox: function($figures, gallery_id) {
			var self = FX.Galleries,
				$items = $figures.find('a');

			$items.attr('rel', gallery_id);
			$items.fancybox({
				helpers: {
					thumbs: {
						width: 100,
						height: 100
					},
					media: {}
				}
			});
		}

    };


	/* ---------------------------------------------------------------------
		Mobile Menu Toggle
	------------------------------------------------------------------------ */
	$('.menu-toggle').click( function() {
		$('.menu-toggle, .nav--main, #masthead').toggleClass('active');
	});

	/* ---------------------------------------------------------------------
		Mainobile - Main Nav Toggles
	------------------------------------------------------------------------ */

	$('.main-menu-toggle').click( function() {
		$('.nav-primary').toggleClass('active');
	});

	/* ---------------------------------------------------------------------
		Mobile - Subnav Menu Toggles
	------------------------------------------------------------------------ */
	$('li.ubermenu-item-has-children > a').after('<span class="sub-menu-toggle icon-chevron-small-down hidden-md hidden-lg"></span>');


	$('.sub-menu-toggle').click( function() {
		var $this = $(this),
			$parent = $this.parent("li"),
			$wrap = $parent.children(".sub-menu");
		$wrap.toggleClass("toggled");
		$parent.toggleClass("toggled");
		$this.toggleClass("toggled");
	});




    /* ---------------------------------------------------------------------
		Homepage - Coupon Section - slide in
	------------------------------------------------------------------------ */
    // Cache the Window object
    $window = $(window);

    // Slide In Effect
    (function($) {
		$.fn.visible = function(partial) {
			var $t = $(this),
			$w = $(window),
			viewTop = $w.scrollTop(),
			viewBottom = viewTop + $w.height(),
			_top = $t.offset().top,
			_bottom = _top + $t.height(),
			compareTop = partial === true ? _bottom : _top,
			compareBottom = partial === true ? _top : _bottom;
			return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
		};
	})(jQuery);

	var win = $(window);
	var allMods = $(".home-content-first__slide-in");
	allMods.each(function(i, el) {
		var el = $(el);
		if (el.visible(true)) {
			el.addClass("come-in");
		}
	});
	win.scroll(function(event) {
		allMods.each(function(i, el) {
			var el = $(el);
			if (el.visible(true)) {
				el.addClass("come-in");
			}
		});
    });


    /* ---------------------------------------------------------------------
		Sticky Header
	------------------------------------------------------------------------ */
	jQuery(window).scroll(function(){
		var fromTopPx = 100; // distance to trigger
		var scrolledFromtop = jQuery(window).scrollTop();
		if ( scrolledFromtop > fromTopPx ) {
			jQuery('.page-header').addClass('sticky');
		} else {
			jQuery('.page-header').removeClass('sticky');
		}

	});

    return FX;

}(FX || {}, jQuery));
